<template>
  <div class="app-wrapper">
    <div class="app-container img-bgr" :style="isDashboard ? { '--bg-image': `url(${backgroundImage})` } : {}">
      <SidebarNavigation :collapsed="sidebarCollapsed" @toggle-sidebar="toggleSidebar"
        @section-changed="changeSection" />

      <div class="main-content" :class="{ 'expanded': sidebarCollapsed }">
        <div class="content-area">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarNavigation from './SidebarNavigation.vue';
import { useAuthStore } from '../stores/auth';

export default {
  name: 'WorkspaceComponent',
  components: {
    SidebarNavigation,
  },
  data() {
    // Determine initial collapsed state
    let initialCollapsed = false;
    if (typeof window !== 'undefined') {
      if (window.innerWidth >= 769 && window.innerWidth < 1200) {
        initialCollapsed = true;
      } else {
        try {
          const saved = localStorage.getItem('sidebar-collapsed');
          initialCollapsed = saved ? JSON.parse(saved) : false;
        } catch {
          initialCollapsed = false;
        }
      }
    }
    return {
      sidebarCollapsed: initialCollapsed,
      backgroundImage: require('@/assets/gradient_bgr.png'),
      sectionTitles: {
        calendar: 'Calendar',
        hours: 'Business Hours',
        services: 'Services',
        providers: 'Providers',
        clients: 'Clients',
        business: 'Business Settings',
        tags: 'Tags'
      }
    };
  },
  setup() {
    const authStore = useAuthStore();
    return { authStore };
  },
  computed: {
    currentSection() {
      // Extract section from current route
      const path = this.$route.path;
      if (path.includes('/workspace/clients')) return 'clients';
      if (path.includes('/workspace/services')) return 'services';
      if (path.includes('/workspace/providers')) return 'providers';
      if (path.includes('/workspace/calendar')) return 'calendar';
      if (path.includes('/workspace/hours')) return 'hours';
      if (path.includes('/workspace/settings/tags')) return 'tags';
      if (path.includes('/workspace/settings')) return 'settings';

      // Default section
      return 'calendar';
    },
    currentSectionTitle() {
      return this.sectionTitles[this.currentSection] || 'Dashboard';
    },
    isAuthenticating() {
      // Show loading while auth is being checked
      return this.authStore.isLoading || !this.authStore.isAuthenticated;
    },
    isDashboard() {
      return this.$route.path.includes('/dashboard');
    }
  },
  methods: {
    toggleSidebar(value) {
      if (value !== undefined) {
        this.sidebarCollapsed = value;
      } else {
        this.sidebarCollapsed = !this.sidebarCollapsed;
      }
    },
    changeSection(sectionId, subsectionId) {
      // Navigate using router instead of changing local state
      if (sectionId === 'settings' && subsectionId) {
        this.$router.push(`/workspace/settings/${subsectionId}`);
      } else {
        this.$router.push(`/workspace/${sectionId}`);
      }
    }
  }
};
</script>

<style scoped>
/* App Layout */
.app-container {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  transition: margin-left 0.3s ease;
  margin-left: 220px;
  min-width: 0;
  overflow-x: hidden;
}

.main-content.expanded {
  margin-left: 70px;
}

.content-area {
  padding: 52px 24px 24px 24px;
  overflow-x: hidden;
}

/* .gradient-background-layer {
  position: absolute;
  inset: 0;
  z-index: -2;
  overflow: hidden;
  pointer-events: none;
}


/* Responsive Styles */
@media (max-width: 768px) {
  .app-container {
    min-height: 100vh;
    min-height: 100dvh;
  }

  .main-content {
    margin-left: 0 !important;
  }

  .content-area {
    padding: 50px 16px 24px 16px !important;
  }
}

@media (max-width: 480px) {
  .img-bgr {
    background-image: var(--bg-image);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
}
</style>